/* /* eslint-disable *\/ */
/**
 * // This file is auto-generated by Orval. Do not edit manually.
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ApplyReferralCodeInputDTO } from '../../../shared/types/api/applyReferralCodeInputDTO';

import type { GetCurrentUserOutputDTO } from '../../../shared/types/api/getCurrentUserOutputDTO';

import type { GetMyBankAccountsOutputDTO } from '../../../shared/types/api/getMyBankAccountsOutputDTO';

import type { GetMyReferralOutputDTO } from '../../../shared/types/api/getMyReferralOutputDTO';

import type { GetMyWalletSummaryApiV1UsersMeWalletSummaryGetParams } from '../../../shared/types/api/getMyWalletSummaryApiV1UsersMeWalletSummaryGetParams';

import type { GetWalletSummaryOutputDTO } from '../../../shared/types/api/getWalletSummaryOutputDTO';

import type { HTTPValidationError } from '../../../shared/types/api/hTTPValidationError';

import type { RecordTermsDecisionInputDTO } from '../../../shared/types/api/recordTermsDecisionInputDTO';

import type { UpdateUserOnboardingCompleteRestInputDTO } from '../../../shared/types/api/updateUserOnboardingCompleteRestInputDTO';

import { customInstance } from '../../../shared/api/api-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get Current User
 */
export const getCurrentUserApiV1UsersMeGet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetCurrentUserOutputDTO>(
    { url: `/api/v1/users/me`, method: 'GET', signal },
    options
  );
};

export const getGetCurrentUserApiV1UsersMeGetQueryKey = () => {
  return [`/api/v1/users/me`] as const;
};

export const getGetCurrentUserApiV1UsersMeGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserApiV1UsersMeGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>> = ({
    signal,
  }) => getCurrentUserApiV1UsersMeGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrentUserApiV1UsersMeGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>
>;
export type GetCurrentUserApiV1UsersMeGetQueryError = unknown;

export function useGetCurrentUserApiV1UsersMeGet<
  TData = Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCurrentUserApiV1UsersMeGet<
  TData = Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCurrentUserApiV1UsersMeGet<
  TData = Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Current User
 */

export function useGetCurrentUserApiV1UsersMeGet<
  TData = Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserApiV1UsersMeGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCurrentUserApiV1UsersMeGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return the authenticated user's bank accounts from the identity provider.
 * @summary Get My Bank Accounts
 */
export const getMyBankAccountsApiV1UsersMeBankAccountsGet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetMyBankAccountsOutputDTO>(
    { url: `/api/v1/users/me/bank-accounts`, method: 'GET', signal },
    options
  );
};

export const getGetMyBankAccountsApiV1UsersMeBankAccountsGetQueryKey = () => {
  return [`/api/v1/users/me/bank-accounts`] as const;
};

export const getGetMyBankAccountsApiV1UsersMeBankAccountsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyBankAccountsApiV1UsersMeBankAccountsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>
  > = ({ signal }) => getMyBankAccountsApiV1UsersMeBankAccountsGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyBankAccountsApiV1UsersMeBankAccountsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>
>;
export type GetMyBankAccountsApiV1UsersMeBankAccountsGetQueryError = unknown;

export function useGetMyBankAccountsApiV1UsersMeBankAccountsGet<
  TData = Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
          TError,
          Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyBankAccountsApiV1UsersMeBankAccountsGet<
  TData = Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
          TError,
          Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyBankAccountsApiV1UsersMeBankAccountsGet<
  TData = Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get My Bank Accounts
 */

export function useGetMyBankAccountsApiV1UsersMeBankAccountsGet<
  TData = Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyBankAccountsApiV1UsersMeBankAccountsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyBankAccountsApiV1UsersMeBankAccountsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary User Complete Onboarding
 */
export const userCompleteOnboardingApiV1UsersMeOnboardingCompletePost = (
  updateUserOnboardingCompleteRestInputDTO: UpdateUserOnboardingCompleteRestInputDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/v1/users/me/onboarding/complete`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: updateUserOnboardingCompleteRestInputDTO,
      signal,
    },
    options
  );
};

export const getUserCompleteOnboardingApiV1UsersMeOnboardingCompletePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userCompleteOnboardingApiV1UsersMeOnboardingCompletePost>>,
    TError,
    { data: UpdateUserOnboardingCompleteRestInputDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userCompleteOnboardingApiV1UsersMeOnboardingCompletePost>>,
  TError,
  { data: UpdateUserOnboardingCompleteRestInputDTO },
  TContext
> => {
  const mutationKey = ['userCompleteOnboardingApiV1UsersMeOnboardingCompletePost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userCompleteOnboardingApiV1UsersMeOnboardingCompletePost>>,
    { data: UpdateUserOnboardingCompleteRestInputDTO }
  > = (props) => {
    const { data } = props ?? {};

    return userCompleteOnboardingApiV1UsersMeOnboardingCompletePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserCompleteOnboardingApiV1UsersMeOnboardingCompletePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof userCompleteOnboardingApiV1UsersMeOnboardingCompletePost>>
>;
export type UserCompleteOnboardingApiV1UsersMeOnboardingCompletePostMutationBody =
  UpdateUserOnboardingCompleteRestInputDTO;
export type UserCompleteOnboardingApiV1UsersMeOnboardingCompletePostMutationError =
  HTTPValidationError;

/**
 * @summary User Complete Onboarding
 */
export const useUserCompleteOnboardingApiV1UsersMeOnboardingCompletePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userCompleteOnboardingApiV1UsersMeOnboardingCompletePost>>,
      TError,
      { data: UpdateUserOnboardingCompleteRestInputDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof userCompleteOnboardingApiV1UsersMeOnboardingCompletePost>>,
  TError,
  { data: UpdateUserOnboardingCompleteRestInputDTO },
  TContext
> => {
  const mutationOptions =
    getUserCompleteOnboardingApiV1UsersMeOnboardingCompletePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get My Referral
 */
export const getMyReferralApiV1UsersMeReferralGet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetMyReferralOutputDTO>(
    { url: `/api/v1/users/me/referral`, method: 'GET', signal },
    options
  );
};

export const getGetMyReferralApiV1UsersMeReferralGetQueryKey = () => {
  return [`/api/v1/users/me/referral`] as const;
};

export const getGetMyReferralApiV1UsersMeReferralGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyReferralApiV1UsersMeReferralGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>
  > = ({ signal }) => getMyReferralApiV1UsersMeReferralGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyReferralApiV1UsersMeReferralGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>
>;
export type GetMyReferralApiV1UsersMeReferralGetQueryError = unknown;

export function useGetMyReferralApiV1UsersMeReferralGet<
  TData = Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
          TError,
          Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyReferralApiV1UsersMeReferralGet<
  TData = Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
          TError,
          Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyReferralApiV1UsersMeReferralGet<
  TData = Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get My Referral
 */

export function useGetMyReferralApiV1UsersMeReferralGet<
  TData = Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyReferralApiV1UsersMeReferralGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyReferralApiV1UsersMeReferralGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Apply Referral Code
 */
export const applyReferralCodeApiV1UsersMeReferralPost = (
  applyReferralCodeInputDTO: ApplyReferralCodeInputDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/v1/users/me/referral`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: applyReferralCodeInputDTO,
      signal,
    },
    options
  );
};

export const getApplyReferralCodeApiV1UsersMeReferralPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyReferralCodeApiV1UsersMeReferralPost>>,
    TError,
    { data: ApplyReferralCodeInputDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyReferralCodeApiV1UsersMeReferralPost>>,
  TError,
  { data: ApplyReferralCodeInputDTO },
  TContext
> => {
  const mutationKey = ['applyReferralCodeApiV1UsersMeReferralPost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyReferralCodeApiV1UsersMeReferralPost>>,
    { data: ApplyReferralCodeInputDTO }
  > = (props) => {
    const { data } = props ?? {};

    return applyReferralCodeApiV1UsersMeReferralPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyReferralCodeApiV1UsersMeReferralPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyReferralCodeApiV1UsersMeReferralPost>>
>;
export type ApplyReferralCodeApiV1UsersMeReferralPostMutationBody = ApplyReferralCodeInputDTO;
export type ApplyReferralCodeApiV1UsersMeReferralPostMutationError = HTTPValidationError;

/**
 * @summary Apply Referral Code
 */
export const useApplyReferralCodeApiV1UsersMeReferralPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof applyReferralCodeApiV1UsersMeReferralPost>>,
      TError,
      { data: ApplyReferralCodeInputDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof applyReferralCodeApiV1UsersMeReferralPost>>,
  TError,
  { data: ApplyReferralCodeInputDTO },
  TContext
> => {
  const mutationOptions = getApplyReferralCodeApiV1UsersMeReferralPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Record Terms Decision
 */
export const recordTermsDecisionApiV1UsersMeTermsDecisionPost = (
  recordTermsDecisionInputDTO: RecordTermsDecisionInputDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/v1/users/me/terms/decision`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: recordTermsDecisionInputDTO,
      signal,
    },
    options
  );
};

export const getRecordTermsDecisionApiV1UsersMeTermsDecisionPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordTermsDecisionApiV1UsersMeTermsDecisionPost>>,
    TError,
    { data: RecordTermsDecisionInputDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordTermsDecisionApiV1UsersMeTermsDecisionPost>>,
  TError,
  { data: RecordTermsDecisionInputDTO },
  TContext
> => {
  const mutationKey = ['recordTermsDecisionApiV1UsersMeTermsDecisionPost'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordTermsDecisionApiV1UsersMeTermsDecisionPost>>,
    { data: RecordTermsDecisionInputDTO }
  > = (props) => {
    const { data } = props ?? {};

    return recordTermsDecisionApiV1UsersMeTermsDecisionPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordTermsDecisionApiV1UsersMeTermsDecisionPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordTermsDecisionApiV1UsersMeTermsDecisionPost>>
>;
export type RecordTermsDecisionApiV1UsersMeTermsDecisionPostMutationBody =
  RecordTermsDecisionInputDTO;
export type RecordTermsDecisionApiV1UsersMeTermsDecisionPostMutationError = HTTPValidationError;

/**
 * @summary Record Terms Decision
 */
export const useRecordTermsDecisionApiV1UsersMeTermsDecisionPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof recordTermsDecisionApiV1UsersMeTermsDecisionPost>>,
      TError,
      { data: RecordTermsDecisionInputDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof recordTermsDecisionApiV1UsersMeTermsDecisionPost>>,
  TError,
  { data: RecordTermsDecisionInputDTO },
  TContext
> => {
  const mutationOptions =
    getRecordTermsDecisionApiV1UsersMeTermsDecisionPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get My Wallet Summary
 */
export const getMyWalletSummaryApiV1UsersMeWalletSummaryGet = (
  params?: GetMyWalletSummaryApiV1UsersMeWalletSummaryGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetWalletSummaryOutputDTO>(
    { url: `/api/v1/users/me/wallet-summary`, method: 'GET', params, signal },
    options
  );
};

export const getGetMyWalletSummaryApiV1UsersMeWalletSummaryGetQueryKey = (
  params?: GetMyWalletSummaryApiV1UsersMeWalletSummaryGetParams
) => {
  return [`/api/v1/users/me/wallet-summary`, ...(params ? [params] : [])] as const;
};

export const getGetMyWalletSummaryApiV1UsersMeWalletSummaryGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
  TError = HTTPValidationError,
>(
  params?: GetMyWalletSummaryApiV1UsersMeWalletSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyWalletSummaryApiV1UsersMeWalletSummaryGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>
  > = ({ signal }) =>
    getMyWalletSummaryApiV1UsersMeWalletSummaryGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyWalletSummaryApiV1UsersMeWalletSummaryGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>
>;
export type GetMyWalletSummaryApiV1UsersMeWalletSummaryGetQueryError = HTTPValidationError;

export function useGetMyWalletSummaryApiV1UsersMeWalletSummaryGet<
  TData = Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetMyWalletSummaryApiV1UsersMeWalletSummaryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyWalletSummaryApiV1UsersMeWalletSummaryGet<
  TData = Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
  TError = HTTPValidationError,
>(
  params?: GetMyWalletSummaryApiV1UsersMeWalletSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMyWalletSummaryApiV1UsersMeWalletSummaryGet<
  TData = Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
  TError = HTTPValidationError,
>(
  params?: GetMyWalletSummaryApiV1UsersMeWalletSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get My Wallet Summary
 */

export function useGetMyWalletSummaryApiV1UsersMeWalletSummaryGet<
  TData = Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
  TError = HTTPValidationError,
>(
  params?: GetMyWalletSummaryApiV1UsersMeWalletSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyWalletSummaryApiV1UsersMeWalletSummaryGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMyWalletSummaryApiV1UsersMeWalletSummaryGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
